/**
 * @file src/lib/utils/looksLikeMarkdown.ts
 *
 * @description Heuristic: does this text use markdown (headings, bullet or numbered lists, bold)? Needs at least two
 * markdown lines so a single stray "-" or "#" in plain text is not mistaken for markdown.
 */

const MARKDOWN_LINE = /^\s{0,3}(#{1,6}\s+\S|[-*+]\s+\S|\d+[.)]\s+\S)|\*\*[^*\n]+\*\*|__[^_\n]+__/;

export function looksLikeMarkdown(text: string): boolean {
  let hits = 0;
  for (const line of text.split("\n")) {
    if (MARKDOWN_LINE.test(line) && ++hits >= 2) return true;
  }
  return false;
}
